import * as React from 'react'
import { cn } from '@/lib/utils'

function Input({
  className,
  type = 'text',
  ref,
  ...props
}: React.InputHTMLAttributes<HTMLInputElement> & { ref?: React.Ref<HTMLInputElement> }) {
  return (
    <input
      ref={ref}
      type={type}
      data-slot="input"
      className={cn(
        'h-10 w-full rounded-sm border border-line-strong bg-surface px-3 text-sm text-fg',
        'placeholder:text-fg-muted',
        'transition-colors hover:border-line-strong',
        'disabled:cursor-not-allowed disabled:opacity-60',
        'aria-[invalid=true]:border-danger aria-[invalid=true]:hover:border-danger',
        className,
      )}
      {...props}
    />
  )
}

export { Input }
